import { useHead } from '@vueuse/head'
import { computed, onBeforeMount } from 'vue'

import { useHomepageStore } from '@/stores/homepageComponents'

export const useHomepageSeo = () => {
  useHead({
    title: useSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useSeoDescription()
      },
      {
        property: 'og:title',
        content: useSeoTitle()
      },
      {
        property: 'og:description',
        content: useSeoDescription()
      }
    ]
  })
}

export const fetchHomepageSeoStore = () => {
  const homepageStore = useHomepageStore()

  onBeforeMount(async () => {
    try {
      await homepageStore.fetchAllHomepageComponents()
    } catch (error) {
      console.error('Error during fetching homepage components:', error)
    }
  })
}

export const useSeoTitle = () => {
  const homepageStore = useHomepageStore()
  return computed(() => {
    if (homepageStore.getHomepageData?.seo_home?.[0]?.fields?.title) {
      return homepageStore.getHomepageData.seo_home[0].fields.title
    }
    return 'Default Title'
  })
}

export const useSeoDescription = () => {
  const homepageStore = useHomepageStore()
  return computed(() => {
    if (homepageStore.getHomepageData?.seo_home?.[0]?.fields?.description) {
      return homepageStore.getHomepageData.seo_home[0].fields.description
    }
    return 'Default Description'
  })
}
export const useLoadingState = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageLoading)
}
